import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

function FacebookTriggerNode({ data, selected }) {
  const { pageId, pageName, formId, formName } = data.config || {};
  const isConfigured = !!(pageId && formId);

  return (
    <div
      className={`rounded-xl border-2 bg-white dark:bg-gray-900 shadow-sm min-w-[200px] transition-all ${
        selected
          ? 'border-[#1877F2] shadow-blue-200/60 dark:shadow-blue-900/30'
          : 'border-gray-200 dark:border-gray-700'
      }`}
    >
      {/* Header */}
      <div className="flex items-center gap-2.5 px-3.5 py-2.5 bg-[#1877F2]/8 dark:bg-[#1877F2]/15 rounded-t-[10px] border-b border-gray-200 dark:border-gray-700">
        <div className="w-5 h-5 rounded bg-[#1877F2] flex items-center justify-center shrink-0">
          <svg viewBox="0 0 24 24" fill="white" className="w-3 h-3">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        </div>
        <span className="text-xs font-semibold text-[#1877F2]">Facebook Lead Trigger</span>
      </div>

      {/* Body */}
      <div className="px-3.5 py-2.5">
        {isConfigured ? (
          <div className="space-y-1">
            <div className="flex items-center gap-1.5">
              <span className="text-[10px] text-gray-400 uppercase tracking-wide w-8 shrink-0">Page</span>
              <span className="text-xs text-gray-700 dark:text-gray-300 font-medium truncate max-w-[130px]" title={pageName || pageId}>
                {pageName || pageId}
              </span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="text-[10px] text-gray-400 uppercase tracking-wide w-8 shrink-0">Form</span>
              <span className="text-xs text-gray-500 dark:text-gray-400 truncate max-w-[130px]" title={formName || formId}>
                {formName || formId}
              </span>
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400 shrink-0" />
            <span className="text-xs text-gray-400">Click to configure</span>
          </div>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-[#1877F2] !w-3 !h-3 !border-2 !border-white dark:!border-gray-900"
      />
    </div>
  );
}

export default memo(FacebookTriggerNode);
